module.exports = __webpack_public_path__ + "img/aeroland-payment-image-03.8bc41a44.png";